import {
  CKButton,
  CKCheckboxNext,
  CKLayoutHorizontal,
  CKTextFieldNext,
} from 'clearkit';
import { isEqual } from 'lodash';
import { FC, useState } from 'react';

import { ButtonContainer } from '~/components/unified/ButtonContainer';
import { SettingsCard } from '~/components/unified/SettingsCard';

import { UserProfile } from './types';
type FormUserProfileProps = {
  onChange: (value: UserProfile) => void;
  value: UserProfile;
};

export const FormUserProfile: FC<FormUserProfileProps> = ({
  onChange,
  value,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [userData, setUserData] = useState<UserProfile>(value);

  const isDirty = !isEqual(userData, value);

  const handleSubmit = async () => {
    setIsLoading(true);

    await onChange(userData);

    setIsLoading(false);
  };

  const setFieldValue = (field: string, value: any) => {
    setUserData((prevState) => ({ ...prevState, [field]: value }));
  };

  return (
    <SettingsCard>
      <SettingsCard.Header>
        <SettingsCard.Heading>Profile</SettingsCard.Heading>
      </SettingsCard.Header>
      <SettingsCard.Body className="grid gap-6">
        <CKLayoutHorizontal>
          <CKTextFieldNext
            className="grow"
            id="firstName"
            onChange={(value) => setFieldValue('firstName', value)}
            placeholder="Enter first name"
            value={userData.firstName ?? ''}
          >
            <CKTextFieldNext.Label>First name</CKTextFieldNext.Label>
          </CKTextFieldNext>
          <CKTextFieldNext
            className="grow"
            id="lastName"
            onChange={(value) => setFieldValue('lastName', value)}
            placeholder="Enter last name"
            value={userData.lastName ?? ''}
          >
            <CKTextFieldNext.Label>Last name</CKTextFieldNext.Label>
          </CKTextFieldNext>
        </CKLayoutHorizontal>
        <div className="mt-4">
          <CKCheckboxNext
            checked={!!userData.mailing}
            id="mailing"
            onChange={(checked) => setFieldValue('mailing', checked)}
          >
            Receive Clearbit product updates and news via email?
          </CKCheckboxNext>
        </div>
      </SettingsCard.Body>
      <SettingsCard.Footer>
        <ButtonContainer>
          <CKButton
            isDisabled={isLoading || !isDirty}
            onClick={() => setUserData(value)}
            type="button"
          >
            Discard changes
          </CKButton>
          <CKButton
            isDisabled={!isDirty}
            isLoading={isLoading}
            onClick={handleSubmit}
            variant="bold"
            variantColor="blue"
          >
            Save changes
          </CKButton>
        </ButtonContainer>
      </SettingsCard.Footer>
    </SettingsCard>
  );
};
